(function() {
	function onYouTubeIframeAPIReady(elmentID, youtubeID) {
		try {
			new YT.Player(elmentID, {
				videoId: youtubeID,
				playerVars: {
					autoplay: 1, // Auto-play the video on load
					controls: 0, // Show pause/play buttons in player
					showinfo: 1, // Hide the video title
					modestbranding: 1, // Hide the Youtube Logo
					loop: 1, // Run the video in a loop
					fs: 0, // Hide the full screen button
					cc_load_policy: 0, // Hide closed captions
					iv_load_policy: 3, // Hide the Video Annotations
					autohide: 1, // Hide video controls when playing
					playsinline: 1, //forbid fullscreen on ios
				},
				events: {
					onReady: (e) => {
						e.target.mute();
						e.target.playVideo();
						e.target.h.classList.add("video-loaded");
					},
				},
			});
		} catch (error) {
			console.log(error);
		}
	}

	function loadVideos(items) {
		items.forEach((el) => {
			const id = el.id;
			const isLoaded = el.classList.contains("video-loaded");
			if (!isLoaded && TTGHelpers.isInViewport(el)) {
				const youtubeID = el.getAttribute("data-id");
				onYouTubeIframeAPIReady(id, youtubeID);
				el.classList.add("video-loaded");
			}
		});
	}

	window.addEventListener("load", function() {
		const videos = document.querySelectorAll(".video-youtube");
		loadVideos(videos);
	});
	window.addEventListener(
		"scroll",
		function() {
			const videos = document.querySelectorAll(".video-youtube");
			loadVideos(videos);
		},
		false,
	);
})();



// WEBPACK FOOTER //
// ./js/components/video.js